module.exports = __webpack_public_path__ + "img/vector-back.41a7eeec.svg";